import { Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"

interface MaxStorageRemaininglabelProps {
    maxStorage: number
    currentStorage: number
}

export const MaxStorageRemainingLabel: FunctionComponent<MaxStorageRemaininglabelProps> = ({
    maxStorage,
    currentStorage
}) => {
    return (
        <Typography variant="body2">
            {`${(maxStorage - currentStorage).toFixed(2)} GB remaining`}
        </Typography>
    )
}
